import { render } from "./MaterialsHostelsTable.vue?vue&type=template&id=585a9624&scoped=true"
import script from "./MaterialsHostelsTable.vue?vue&type=script&lang=js"
export * from "./MaterialsHostelsTable.vue?vue&type=script&lang=js"

import "./MaterialsHostelsTable.vue?vue&type=style&index=0&id=585a9624&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-585a9624"]])

export default __exports__